import Vue from "vue";
import Router from "vue-router";
import store from "./store.js";

import Map from "./views/Map.vue";
import CoronaVirus from "./views/CoronaVirus.vue";
import Home from "./views/Home.vue";
import Topics from "./views/TopicIndex.vue";
import TopicShow from "./views/TopicShow.vue";
import SearchResult from "./views/SearchResult.vue";
import Login from "./views/Login.vue";
import TopicCreate from "./views/TopicCreate.vue";
import WechatLogin from "./views/WechatLogin.vue";
import WechatConnect from "./views/WechatConnect.vue";
import MyTopics from "./views/MyTopics.vue";
import ResetPassword from "./views/ResetPassword.vue";
import UserSummary from "./views/UserSummary.vue";
import Verification from "./views/Verification.vue";
import TagResult from "./views/TagResult.vue";
import UserEdit from "./components/UserEdit.vue";
import UserImport from "./components/UserImport.vue";
import UserSettings from "./components/UserSettings.vue";
import ReplyNotifications from "./components/ReplyNotifications.vue";
import Messages from "./components/messages/Messages.vue";
import Admin from "./views/Admin";
import terms from "./views/terms";
import privacy from "./views/privacy";
import UserProfilePageEdit from "@/components/UserProfilePageEdit";
import UserProfilePage from "./views/UserProfilePage.vue";
import Subscription from "@/views/Subscription";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      meta: {
        layout: "empty"
      }
    },
    {
      path: "/categories/corona",
      name: "corona",
      component: CoronaVirus,
      meta: {
        layout: "topic"
      }
    },
    // show all topic in the category
    {
      path: "/categories/:id",
      name: "categories",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      // component: () =>
      //   import(/* webpackChunkName: "about" */ "./views/About.vue")
      component: Topics,
      props: route => ({ id: route.params.id }),
      meta: {
        layout: "topic"
      }
    },
    // show all topics with the same search text
    {
      path: "/search/:text",
      name: "search",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      // component: () =>
      //   import(/* webpackChunkName: "about" */ "./views/About.vue")
      component: SearchResult,
      props: route => ({ text: route.params.text }),
      meta: {
        layout: "topic"
      }
    },
    // show all topics with same tags
    {
      path: "/tags/:tagId/:slug?",
      name: "tag",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      // component: () =>
      //   import(/* webpackChunkName: "about" */ "./views/About.vue")
      component: TagResult,
      props: route => ({
        tagName: route.query.tagName,
        tagId: route.params.tagId
      }),
      meta: {
        layout: "topic"
      }
    },
    {
      path: "/map",
      name: "map",
      component: Map,
      meta: {
        requiresAuth: true,
        layout: "topic"
      }
    },
    // topics
    //create topic
    {
      path: "/topics",
      name: "topic.create",
      component: TopicCreate,
      props: route => ({ id: route.query.id }),
      meta: {
        requiresAuth: true,
        layout: "empty"
      }
    },
    // show topic detail
    {
      path: "/topics/:id/:slug?",
      name: "topic.show",
      component: TopicShow,
      props: route => ({ id: route.params.id, admin: route.query.admin }),
      meta: {
        layout: "empty"
      }
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      props: route => ({
        action: route.query.action,
        redirect: route.query.redirect
      }),
      meta: {
        layout: "empty"
      }
    },
    {
      path: "/wechat/login",
      name: "wechat.login",
      component: WechatLogin,
      props: route => ({
        code: route.query.code,
        state: route.query.state
      }),
      meta: {
        layout: "empty"
      }
    },
    {
      path: "/wechat/connect",
      name: "wechat.connect",
      component: WechatConnect,
      props: route => ({
        code: route.query.code,
        state: route.query.state
      }),
      meta: {
        layout: "empty"
      }
    },
    {
      path: "/password/reset/:token",
      name: "password.reset",
      component: ResetPassword,
      props: route => ({
        token: route.params.token
      }),
      meta: {
        layout: "empty"
      }
    },
    {
      path: "/users/:id",
      name: "user",
      component: UserSummary,
      props: route => ({
        id: route.params.id
      }),
      meta: {
        requiresAuth: true,
        layout: "empty"
      }
    },
    {
      path: "/users/:id/profile",
      name: "userProfilePage",
      component: UserProfilePage,
      props: route => ({
        id: route.params.id
      }),
      meta: {
        requiresAuth: true,
        layout: "empty"
      }
    },
    {
      path: "/user/me",
      name: "me",
      component: MyTopics,
      meta: {
        requiresAuth: true,
        layout: "profile"
      }
    },
    {
      path: "/user/edit",
      name: "userEdit",
      component: UserEdit,
      meta: {
        requiresAuth: true,
        layout: "profile"
      }
    },
    {
      path: "/user/subscription",
      name: "userSubscription",
      component: Subscription,
      meta: {
        requiresAuth: true,
        layout: "profile"
      }
    },
    {
      path: "/terms",
      name: "terms",
      component: terms,
      meta: {
        requiresAuth: false,
        layout: "empty"
      }
    },
    {
      path: "/privacy",
      name: "privacy",
      component: privacy,
      meta: {
        requiresAuth: false,
        layout: "empty"
      }
    },
    {
      path: "/user/profile",
      name: "userProfileEdit",
      component: UserProfilePageEdit,
      meta: {
        requiresAuth: true,
        layout: "profile"
      }
    },
    {
      path: "/users/profile/:id",
      name: "userProfileEdit",
      component: UserProfilePageEdit,
      props: route => ({
        id: route.params.id
      }),
      meta: {
        requiresAuth: true,
        layout: "profile"
      }
    },
    {
      path: "/user/settings",
      name: "userSettings",
      component: UserSettings,
      meta: {
        requiresAuth: true,
        layout: "profile"
      }
    },
    {
      path: "/import/:token?",
      name: "userImport",
      component: UserImport,
      props: route => ({
        userToken: route.params.token
      }),
      meta: {
        requiresAuth: false,
        layout: "empty"
      }
    },
    {
      path: "/notifications/replies",
      name: "notificationsReplies",
      component: ReplyNotifications,
      meta: {
        requiresAuth: true,
        layout: "profile"
      }
    },
    {
      path: "/messages",
      name: "messages",
      component: Messages,
      props: route => ({
        id: route.query.id
      }),
      meta: {
        requiresAuth: true,
        layout: "profile"
      }
    },
    {
      path: "/verification/:token",
      name: "verification",
      component: Verification,
      props: route => ({
        verification_token: route.params.token,
        email: route.query.email
      }),
      meta: {
        requiresAuth: false,
        layout: "empty"
      }
    },
    {
      path: "/admin",
      name: "admin",
      component: Admin,
      meta: {
        requiresAuth: false,
        layout: "empty"
      }
    },
    {
      path: "*",
      name: "redirectToHome",
      component: Home,
      meta: {
        requiresAuth: false,
        layout: "topic"
      }
    }
  ]
});
router.beforeEach((to, from, next) => {
  store.commit("setLayout", to.matched[0].meta.layout);
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next();
      return;
    }
    next({
      path: "/login",
      query: { redirect: to.fullPath }
    });
  } else {
    next();
  }
});
export default router;
